import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, unref as _unref } from "vue";
var _hoisted_1 = {
  class: "note-module"
};
var _hoisted_2 = {
  key: 0,
  class: "list-loading"
};
var _hoisted_3 = {
  key: 1,
  class: "note-list-container"
};
var _hoisted_4 = {
  class: "header-txt"
};
var _hoisted_5 = {
  key: 0,
  class: "top nowarp"
};
var _hoisted_6 = {
  key: 1,
  class: "nowarp"
};
var _hoisted_7 = {
  key: 2,
  class: "nowarp clip"
};
var _hoisted_8 = {
  class: "from"
};
import { ref, onMounted } from 'vue';
import { getNoteList } from '@/api/home';
import { MessagePlugin } from 'tdesign-vue-next';
import { getStore } from '@/util/store';
export default {
  __name: 'index',
  setup: function setup(__props) {
    var userInfo = getStore({
      name: 'userInfo'
    }); // 获取userInfo
    var noteList = ref([]);
    var pageCurrent = ref(1);
    var image = require('./note-empty.png');
    var loadingData = ref(false);
    var isFinish = ref(false);
    var visibleNote = ref(false);
    var onScroll = function onScroll(e) {
      var _e$target = e.target,
        scrollTop = _e$target.scrollTop,
        clientHeight = _e$target.clientHeight,
        scrollHeight = _e$target.scrollHeight;
      if (scrollHeight - (scrollTop + clientHeight) < 100 && !loadingData.value && !isFinish.value) {
        pageCurrent.value++;
        getData();
      }
    };
    var getData = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _noteList$value, query, _yield$getNoteList, data, _data$data, records, total, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              if (!(loadingData.value || isFinish.value)) {
                _context.n = 1;
                break;
              }
              return _context.a(2);
            case 1:
              _context.p = 1;
              loadingData.value = true;
              query = {
                current: pageCurrent.value,
                size: 8
              };
              _context.n = 2;
              return getNoteList(userInfo.id, 0, query);
            case 2:
              _yield$getNoteList = _context.v;
              data = _yield$getNoteList.data;
              _data$data = data.data, records = _data$data.records, total = _data$data.total;
              (_noteList$value = noteList.value).push.apply(_noteList$value, _toConsumableArray(records ? records : []));
              isFinish.value = 8 * pageCurrent.value >= total;
              console.log(data);
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              console.log(_t);
            case 4:
              _context.p = 4;
              loadingData.value = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, null, [[1, 3, 4, 5]]);
      }));
      return function getData() {
        return _ref.apply(this, arguments);
      };
    }();
    var handleCreate = function handleCreate() {
      console.log(visibleNote.value, 'visibleNote.value');
      visibleNote.value = true;
    };
    var refreshPage = function refreshPage() {
      pageCurrent.value = 1;
      noteList.value = [];
      getData();
    };
    var handleAddNote = function handleAddNote(val) {
      MessagePlugin.success('笔记保存成功');
      refreshPage();
    };
    onMounted(function () {
      getData();
    });
    return function (_ctx, _cache) {
      var _noteList$value2, _noteList$value3;
      var _component_Loading = _resolveComponent("Loading");
      var _component_hxhy_note_item = _resolveComponent("hxhy-note-item");
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_button = _resolveComponent("t-button");
      var _component_Empty = _resolveComponent("Empty");
      var _component_noteDialog = _resolveComponent("noteDialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [loadingData.value && !((_noteList$value2 = noteList.value) !== null && _noteList$value2 !== void 0 && _noteList$value2.length) ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_Loading), _cache[1] || (_cache[1] = _createElementVNode("span", null, "加载中...", -1))])) : _createCommentVNode("", true), noteList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", {
        class: "note-list",
        onScroll: onScroll
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(noteList.value, function (item) {
        return _openBlock(), _createBlock(_component_hxhy_note_item, {
          id: 'note-' + item.id,
          key: item.id,
          data: item,
          class: "note-item",
          editable: false
        }, {
          top_left: _withCtx(function () {
            return [_createElementVNode("span", _hoisted_4, [item.topStatus && !_ctx.searchContent ? (_openBlock(), _createElementBlock("span", _hoisted_5, "置顶")) : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(item.updateTime), 1)), item.type > 0 ? (_openBlock(), _createElementBlock("span", _hoisted_7, [_cache[2] || (_cache[2] = _createTextVNode("  来自", -1)), _createElementVNode("span", _hoisted_8, _toDisplayString(item.dataTitle), 1)])) : _createCommentVNode("", true)])];
          }),
          _: 2
        }, 1032, ["id", "data"]);
      }), 128))], 32), _createElementVNode("div", {
        class: "add-icon-box",
        onClick: handleCreate
      }, [_createVNode(_component_svg_icon, {
        name: "add-icon",
        size: "24"
      })])])) : _createCommentVNode("", true), !((_noteList$value3 = noteList.value) !== null && _noteList$value3 !== void 0 && _noteList$value3.length) && !loadingData.value ? (_openBlock(), _createBlock(_component_Empty, {
        key: 2,
        icon: _unref(image),
        fullHeight: true
      }, {
        description: _withCtx(function () {
          return [_cache[4] || (_cache[4] = _createElementVNode("div", {
            class: "empty-text"
          }, "暂无笔记", -1)), _createVNode(_component_t_button, {
            theme: "primary",
            onClick: handleCreate
          }, {
            default: _withCtx(function () {
              return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode("添加笔记", -1)]));
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["icon"])) : _createCommentVNode("", true), visibleNote.value ? (_openBlock(), _createBlock(_component_noteDialog, {
        key: 3,
        onAddNote: handleAddNote,
        visibleNote: visibleNote.value,
        "onUpdate:visibleNote": _cache[0] || (_cache[0] = function ($event) {
          return visibleNote.value = $event;
        })
      }, null, 8, ["visibleNote"])) : _createCommentVNode("", true)]);
    };
  }
};